module.exports = __webpack_public_path__ + "img/test-and-award.e08aab91.png";